import React from "react";
import Fit from "./Fit";
import "./HeldUp.scss";

const PrintFitCertificate = () => {
  return <Fit noHeader />;
};
export default PrintFitCertificate;
